import React from 'react'
import { startGetReporteXls } from '../../../context/actions/reportesActions';
import { useDispatch } from 'react-redux';

export const useForma = () => {
    const dispatch = useDispatch();
  
    const [body, setBody] = React.useState({});

    const handleSelect = (value) => {
      setBody({ ...body, TipoReporte: value });
    };
  
    const handleRange = (value, strValue) => {
      setBody({ ...body, FechaInicio: strValue[0], FechaFin: strValue[1] });
    };
  
    const handleSubmit = () => {
   dispatch(startGetReporteXls(body));
    };
  
    const isDisabled = !body.TipoReporte || !body.FechaInicio || !body.FechaFin;

    return {
        handleSelect,
        handleRange,
        handleSubmit,
        isDisabled
    }
}
